"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var setLocalStorageItem = exports.setLocalStorageItem = function setLocalStorageItem(key, val) {
  try {
    var _window = window,
        localStorage = _window.localStorage;

    var serializedValue = JSON.stringify(val);
    localStorage.setItem(key, serializedValue);
  } catch (err) {}
};

var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
  try {
    var _window2 = window,
        localStorage = _window2.localStorage;

    var serializedValue = localStorage.getItem(key);
    if (serializedValue === null) {
      return undefined;
    }
    return JSON.parse(serializedValue);
  } catch (err) {
    return undefined;
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/lib/localStorage/index.js
// module id = 854
// module chunks = 0